
export default[
    {
        show(row,extra){
            return true
            // row.shbj==='1'
        },
        tag:'my-btn',
        type:'detail',
        text:'详情',
        click(row,extra){
            if(row.govchildtype=='1'){
                this.gotoFrame({
                    title:'项目流程',
                    url:'/otc/index.html#/agency/project/detail?zbprocode='+row.by1+'&&ext3='+row.ext3,
                })
            }else{
                if(row.ext3){
                    this.goto({
                        path: '/bidding/project/zfcg/detail',
                        query: {
                            id: row.zbprocode,
                            type:row.ext3,
                            childtype: '',
                        }
                    });
                }else{
                    this.goto({
                        path: '/bidding/project/detail',
                        query: {
                            id: row.procode,
                        }
                    });
                }
                
            }
            
        }
    },{
        show(row,extra){
            return true
        },
        tag:'el-button',
        icon: 'el-icon-s-promotion',
        type:'text',
        text:'进入流程',
        click(row,extra){
            if(row.govchildtype=='1'){
                this.gotoFrame({
                    title:'项目流程',
                    url:'/otc/index.html#/agency/project/flow?zbprocode='+row.by1+'&&ext3='+row.ext3,
                })
            }else{
                this.goto({
                    path: '/bidding/liucheng/index',
                    query: {
                        id: row.by1,
                    }
                });
            }
            

        }
    }
]
